import { SvgIconProps } from '@mui/material';

export const FeaturedDowngradeIcon = (props: SvgIconProps) => {
  return (
    <svg fill="none" {...props} viewBox="0 0 56 56"  xmlns="http://www.w3.org/2000/svg">
      <circle cx="28" cy="28" fill="#FEF3F2" r="28" />
      <circle cx="28" cy="28" fill="#FEE4E2" r="20" />
      <path
        d="M23 29L28 34L33 29M23 22L28 27L33 22"
        stroke="#D92D20"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};
